import { render } from "./DependentListComponent.vue?vue&type=template&id=6b014226&scoped=true"
import script from "./DependentListComponent.vue?vue&type=script&lang=js"
export * from "./DependentListComponent.vue?vue&type=script&lang=js"

import "./DependentListComponent.vue?vue&type=style&index=0&id=6b014226&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b014226"]])

export default __exports__